@import "~rfs/scss";
@import "../variables.scss";

.tooltipWrapper {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  @media (hover: none) {
    left: 0 !important;
    top: 40% !important;
    width: 100%;
    position: fixed;
  }
}

.tooltipWrapper.visible {
  opacity: 1;
}
.tooltip {
  background-color: #000;
  border: 1px solid $border-color;
  padding: 10px 2px;
  border-radius: 5px;
  color: #cecece;
  position: relative;
  z-index: 1;
  text {
    fill: #cecece;
  }

  .countryName {
    @include font-size(26px);
    padding-left: 1em;
  }
  .content {
    display: flex;
    flex-direction: row;
    svg.scaleBar {
      text {
        dominant-baseline: middle;
        @include font-size(12px);
      }
    }
    .mapAndStats {
      display: flex;
      flex-direction: row;
      white-space: nowrap;
      letter-spacing: 0.66pt;
      .groupLabel {
        @include font-size(14px);
      }

      .globalLabel {
        @include font-size(12px);
      }

      .groupRankingLabel {
        @include font-size(10px);
      }

      .globalValue {
        @include font-size(20px);
      }

      .groupRankingValue {
        @include font-size(16px);
      }

      .groupValue {
        @include smallWidth {
          display: block;
          margin-bottom: 0.5em;
        }
      }

      .ranking {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        > span:nth-child(2) {
          padding-left: 1em;
        }
      }
    }

    .right {
      text-align: center;
      padding-left: 1em;
      white-space: nowrap;
      padding-right: 1em;
      @include smallWidth {
        position: absolute;
        right: 0;
        top: 1em;
      }
      .score {
        color: #fff;
        @include font-size(20px);
        padding: 0 0.25em;
      }
      .scoreLabel {
        margin-top: 0.5em;
        font-style: italic;
        @include font-size(12px);
      }
    }
  }

  .bubbleGraphWrapper {
    display: flex;
    justify-content: flex-end;
    padding-right: 1em;
    padding-bottom: 0.5em;
    .bubbleGraph {
      width: 300px;
      height: 116px;
    }
  }
}

.tooltipControls {
  display: none;
  position: relative;
  margin-top: 0.5em;
  pointer-events: all;
  > div {
    display: inline-block;
  }
  .detailsButton {
    margin-left: 1em;
  }
  .closeButton {
    position: absolute;
    right: 1em;
  }
  @include smallWidth {
    display: block;
    @media (hover: hover) {
      display: none;
    }
  }
}
.clickInstructions {
  @include font-size(12px);
  border: 1px solid $border-color;

  background-color: #000;
  border: 1px solid $border-color;
  padding: 0.5em;

  border-radius: 5px;
  color: #cecece;
  display: inline-block;
  transition: transform 0.3s ease-in-out;
  position: absolute;

  transform: translate(0, -3em);
  &.flipX {
    right: 0;
  }

  &.visible {
    transform: translate(0, 1em);
  }

  @media (hover: none) {
    display: none !important;
  }
}
